import { AD_PLACEMENTS } from "@/common/consts";

/**
 * Store module coordinating the EX.CO video player with the Aditude ad
 * framework (WFW-6716).
 *
 * - `isExcoLoaded` is flipped once the EX.CO player script has loaded.
 * - `isExcoSticky` tracks whether the player is currently in its sticky
 *   (floating) state. When it goes sticky we tear down the Aditude mobile
 *   adhesion slot so the two sticky units don't fight for the bottom of the
 *   viewport.
 */
export default {
	namespaced: true,
	state: {
		isExcoLoaded: false,
		isExcoSticky: false,
	},
	mutations: {
		SET_IS_EXCO_LOADED(state, value) {
			state.isExcoLoaded = value;
		},
		SET_IS_EXCO_STICKY(state, value) {
			if (value) {
				window.tude = window.tude || { cmd: [] };
				window.tude.cmd.push(() => {
					window.tude.destroyAds([AD_PLACEMENTS.MOB_ADHESION], false);
				});
			}

			state.isExcoSticky = value;
		},
	},
};
